<template>
	<div class="all-footer">
		<p> Copyright © 2005 - 2024 www.51bsbx.com All Rights Reserved. 武汉金里程信息科技有限公司 版权所有</p>
		<p> 地址：武汉经济技术开发区南太子湖创新谷启迪协信科创园（QDXX-Q20250） 邮编：430000</p>
    <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #1D2023;text-decoration:none">网站备案号：鄂ICP备2024045210号</a>
	</div>
</template>

<script>
export default {
	methods: {
		gotolocation() {
			window.open('https://beian.miit.gov.cn/', '_blank')
		}
	}
}

</script>

<style scoped>
.all-footer {
	width: 100%;
	height: 130px;
	background: #EEF0F0;
	padding: 24px 0px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #1D2023;
	box-sizing: border-box;
}

.beian {
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/base/botFooter.vue